import React from 'react';
import { formatByHint } from './criteriaBarUtils';

export default function CtrWindowsChart({ windowComparison }) {
  if (!windowComparison || typeof windowComparison !== 'object') return null;
  const w = Array.isArray(windowComparison.windows) ? windowComparison.windows : [];
  if (w.length < 2) return null;

  const ctr0 = typeof w[0]?.value === 'number' ? w[0].value : Number(w[0]?.value);
  const ctr1 = typeof w[1]?.value === 'number' ? w[1].value : Number(w[1]?.value);
  const hasBoth = Number.isFinite(ctr0) && Number.isFinite(ctr1) && ctr1 > 0;
  const deltaPct7v7 = hasBoth ? ((ctr0 / ctr1) - 1) * 100 : null;

  const ctrValues = w
    .map((x) => (typeof x?.value === 'number' ? x.value : Number(x?.value)))
    .filter((n) => Number.isFinite(n) && n >= 0);
  const maxVal = ctrValues.length ? Math.max(...ctrValues) : 0;
  const maxForScale = Math.max(0.0005, maxVal * 1.1);

  const chipLabel =
    typeof deltaPct7v7 === 'number' && Number.isFinite(deltaPct7v7)
      ? `7v7: ${deltaPct7v7 > 0 ? '+' : deltaPct7v7 < 0 ? '−' : ''}${Math.abs(deltaPct7v7).toFixed(1)}%`
      : null;
  const chipIsNegative = typeof deltaPct7v7 === 'number' && deltaPct7v7 < 0;

  return (
    <div className="mt-3 rounded-xl border border-white/10 bg-white/5 px-4 py-3">
      <div className="flex items-start justify-between gap-3">
        <div className="text-xs tracking-wide text-white/60 font-semibold">CTR por ventana</div>
        {chipLabel ? (
          <span
            className={`shrink-0 inline-flex items-center rounded-full border px-2.5 py-0.5 text-[10px] font-semibold tabular-nums whitespace-nowrap ${
              chipIsNegative
                ? 'border-rose-400/35 bg-rose-500/15 text-rose-100'
                : 'border-white/15 bg-white/10 text-white/80'
            }`}
            title="Variación del CTR: últimos 7 días vs los 7 días previos"
          >
            {chipLabel}
          </span>
        ) : null}
      </div>

      <div className="mt-3 rounded-lg border border-white/10 bg-white/5 px-3 py-3 pb-4">
        <div className="grid grid-cols-2 gap-4 items-end h-[140px]">
          {w.slice(0, 2).map((win, idx) => {
            const ctr = typeof win?.value === 'number' ? win.value : Number(win?.value);
            const hasCtr = Number.isFinite(ctr) && ctr >= 0;
            const isCritical = win?.is_critical === true;
            const barH = hasCtr && maxForScale > 0 ? Math.max(10, Math.round((ctr / maxForScale) * 130)) : 10;
            const barTone = isCritical ? 'bg-rose-500/45' : 'bg-emerald-500/35';
            const label = String(win?.label || (idx === 0 ? 'Ventana A' : 'Ventana B'));
            const valueLabel = hasCtr ? formatByHint(ctr, windowComparison.format_hint) : '—';
            return (
              <div key={`${label}-${idx}`} className="min-w-0 flex flex-col items-center justify-end gap-2">
                <div className="text-[10px] font-semibold tabular-nums text-white/70 whitespace-nowrap">{valueLabel}</div>
                <div
                  className={`w-full rounded-md ${barTone} border border-white/10`}
                  style={{ height: `${barH}px` }}
                  title={label}
                  aria-label={label}
                />
                <div className="text-[10px] text-white/60 font-semibold text-center leading-snug w-full px-0.5">
                  <div className="truncate" title={label}>{label}</div>
                </div>
              </div>
            );
          })}
        </div>
      </div>
    </div>
  );
}
